export const isUrl = (str) => str ? str.startsWith("http") : false;
export const isDataUrl = (str) => str ? str.startsWith("data:") : false;
export const isInternalFileUrl = (str) => str ? (str.includes("/api/files") || str.includes("/api/v3/documents")) : false;
